import { TestDetail } from './TestDetail';
export { TestDetail };
export default TestDetail;